import { render, staticRenderFns } from "./UiModal.vue?vue&type=template&id=4b788eb8&scoped=true&"
import script from "./UiModal.vue?vue&type=script&lang=js&"
export * from "./UiModal.vue?vue&type=script&lang=js&"
import style0 from "./UiModal.vue?vue&type=style&index=0&id=4b788eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b788eb8",
  null
  
)

export default component.exports